module.exports = __webpack_public_path__ + "media/icons/announce-b9259f8b.png";